import { useLocation } from 'react-router-dom';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { setAffiliateCookie } from 'js/utils/affiliate.util';

export const useAffiliate = () => {
    const location = useLocation();

    useEffectOnce(() => {
        const params = Object.fromEntries(new URLSearchParams(location.search));

        setAffiliateCookie(params);
    }, [location]);
};
